/** @jsxImportSource @emotion/react */

import { Button } from "antd";
import { CommonIcons } from "assets/common/icons";
import { handleFavoriteGame } from "helpers/handleFavouriteGame";
import { handleLoginGame } from "helpers/handleLoginGame";
import { useAppDispatch } from "hooks/app-hook";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectIsAuthenticated, selectUsername } from "store/auth";
import { selectDataSubGameFavourite } from "store/game";
import { SubGameType } from "types/game";

import { GameFavouriteCardStyle } from "./index.style";

const GameFavouriteCard = (props: SubGameType) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const listGameFavourite = useSelector(selectDataSubGameFavourite);
  const username = useSelector(selectUsername);

  const { name, provider_code, picture } = props;

  return (
    <div css={GameFavouriteCardStyle.self}>
      <img src={picture} alt="" />
      <div css={GameFavouriteCardStyle.nameWrapper}>
        <p css={GameFavouriteCardStyle.name}>{name}</p>
        <CommonIcons.Heart
          css={GameFavouriteCardStyle.iconHeart}
          onClick={() =>
            handleFavoriteGame(
              username,
              dispatch,
              props,
              listGameFavourite || [],
              isAuthenticated,
            )
          }
        />
      </div>
      <div css={GameFavouriteCardStyle.provider}>{provider_code}</div>
      <Button
        type="primary"
        css={GameFavouriteCardStyle.btnLoginGame}
        className="btn-login-game"
        onClick={() => handleLoginGame(props, dispatch, navigate)}
      >
        vào trò chơi
      </Button>
    </div>
  );
};

export default GameFavouriteCard;
